export default Object.freeze({

    EventKeys: {
        //Entity Change Events
        SettingsChange: "settingchanged",
        AppointmentChange: "appointmentchanged",
        CustomerChange: "customerchanged",
        ArticleChange: "articlechanged",
        DepartmentChange: "departmentchanged",
        JobChange: "jobchanged",
        JobCategoryChange: "jobcategorychanged",
        OrderChange: "orderchanged",
        MachineChange: "machinechanged",
        MachineTypeChange: "machinetypechanged",
        SupplierChange: "supplierchanged",
        CounterChange: "counterchanged",
        UserChange: "userchanged",
        PartnerCompanyChange: "partnercompanychanged",
        CustomerGroupChange: "customergroupchanged",
        MachineModelChange: "machinemodelchanged",
        ContractChange: "contractchanged",
        UnitChange: "unitchanged",
        CheckListChange: "checklistchanged",

        //System Events
        RefreshClientsEvent: "RefreshClients",
        RefreshUserInfoEvent: "RefreshUserInfo",
        SystemShutdownEvent: "shutdown",

        //Background Task Events
        TaskEvent: "tasks",
        TaskCreatedEvent: "created",
        TaskCompletedEvent: "completed",
        TaskFailedEvent: "failed",
        TaskUpdateEvent: "update",
        SyncEvent: "notification", //TODO: FIX OVERLAP!!!!
        EventualDataEvent: "eventualdata",
        ContractOrderEvent: "contractorderchanged",
        StubEvent: "notification", //TODO: FIX OVERLAP!!!!
        StubFailedEvent: "error", //TODO: FIX OVERLAP!!!!
        JobTaskFailedEvent: "error", //TODO: FIX OVERLAP!!!!
        JobApproveFailedEvent: "error", //TODO: FIX OVERLAP!!!!
        ImportProgressEvent: "import-progress",
        ImportSuccessEvent: "import-success",
        ImportFailedEvent: "import-error",

        // AI
        AI: "AI",
        Chat: "Chat",

        // Customer
        CustomerReachingOut: "customer-reaching-out",
        AgentAcceptedSession: "agent-accepted-session",
    },    

    AppointmentChangeTypes: {
        New: "New",
        Change: "Change",
        Delete: "Delete",
    },

    /** Payload type values for EventualDataEvent (must match backend EventualDataTypeAttribute). */
    EventualDataType: {
        Customer: "Customer",
        Article: "Article",
    },

});